import type { ReactElement } from 'react';
import { partners } from '../../lib/integrations/registry';
import { PartnerCard } from '../../components/integrations/partner-card';

export function IntegrationsOverviewPage(): ReactElement {
  return (
    <div>
      <div className="mb-10">
        <h1 className="text-2xl font-semibold text-white">Integrations</h1>
        <p className="mt-1 text-sm text-gray-500">Games and platforms powered by Ponzinomics SDK</p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {partners.map((partner) => (
          <PartnerCard key={partner.id} partner={partner} />
        ))}
      </div>
    </div>
  );
}
